module.exports = __webpack_public_path__ + "static/img/2.692a71e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/supply/2.png
// module id = VA6r
// module chunks = 1